function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  x: "-150%",
  y: "-62.5%",
  width: "400%",
  height: "225%",
  filterUnits: "objectBoundingBox",
  id: "arrow_svg__a"
}, React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0",
  in: "shadowBlurOuter1"
})), React.createElement("path", {
  d: "M83.693 1.97L88.5-3.5v12l-4.807-5.47a.825.825 0 010-1.06z",
  id: "arrow_svg__b"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "rotate(90 45.5 -33)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("use", {
  fill: "#000",
  filter: "url(#arrow_svg__a)",
  xlinkHref: "#arrow_svg__b"
}), React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#arrow_svg__b",
  "data-override": "fill"
}));

const SvgArrow = ({
  svgRef,
  ...props
}) => React.createElement("svg", _extends({
  width: 20,
  height: 15,
  viewBox: "0 0 20 15",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgArrow, _extends({
  svgRef: ref
}, props)));
export default ForwardRef;